import styles from "./ProgressSpinner.module.css";

const ProgressSpinnerComponent = () => {
  return (
    <div className={styles.spinnerWrapper}>
      <span className={styles.spinner} role="status" aria-label="Loading" />
    </div>
  );
};

export default ProgressSpinnerComponent;
